// extracted by mini-css-extract-plugin
export var backgroundGray = "ServiceRow-module--background-gray--34a31";
export var backgroundWhite = "ServiceRow-module--background-white--688fe";
export var card = "ServiceRow-module--card--8a58e";
export var content = "ServiceRow-module--content--82f6c";
export var footer = "ServiceRow-module--footer--5173c";
export var images = "ServiceRow-module--images--f73b0";
export var serviceRow = "ServiceRow-module--service-row--d02dc";
export var tagline = "ServiceRow-module--tagline--8a057";
export var title = "ServiceRow-module--title--0fd26";
export var variantLeft = "ServiceRow-module--variant-left--7e055";
export var withFooter = "ServiceRow-module--with-footer--3da5a";